 
   const Contact =()=>{
        return(
            <div className="border m-4 p-4 justify-center bg-gray-200 border-r-blue-200">
                
                <h1 className="font-bold"> Contact us Page</h1>
                <h2>I am Rakesh Kushwaha</h2>
                <h2>My Email is rk7518329420@gmail.com</h2>
            </div>
        )
    }

export default Contact;